import React, { useState } from "react";
import classNames from "classnames";
import "./PublicationFeed.scss";

const PublicationFeed: React.FC<JQI.PublicationFeedProps> = ({
  children,
  className,
  limit,
  showMore,
}) => {
  const classList = classNames({
    "article-feed": true,
    "flex": true,
    "flex-col": true,
    "justify-center": true,
    [`${className}`]: !!className,
  });
  const childCount = React.Children.count(children);
  const [count, setCount] = useState(limit || childCount);
  const childrenToShow = React.Children.toArray(children).slice(0, count);
  return (
    <div className={classList}>
      <ul className="publication-feed__list mb-4">
        {
          childrenToShow.map((child, i) => (
            <li className="publication-feed__list-item" key={`publication-feed-item-${i}`}>
              {child}
            </li>
          ))
        }
      </ul>
      {
        (!!showMore && childCount > count) &&
        <div className="py-3">
          <button type="button" className="button button--gray publication-feed__show-more" onClick={() => setCount(childCount)}>Load More Publications</button>
        </div>
      }
    </div>
  );
};

export default PublicationFeed;
